import moment from 'moment'
import { ReportsApi } from '@/reports/api'

export const reportView = {
  data () {
    return {
      loading: true,
      report: [],
      defaultOptions: {
        fields: [],
        stats: ['auctions'],
        filters: [],
        dateAsMillis: true,
        timezone: 'UTC',
      }
    }
  },
  props: {
    options: { type: Object }
  },
  methods: {
    getReport () {
      this.loading = true
      ReportsApi.bqreport(this.processedOptions, this).then((data) => {
        this.report = data.results
        this.loading = false
      }, (e) => {
        console.error(e)
        this.loading.false
      })
    },
    processOptions (options) {
      return options
    }
  },
  computed: {
    processedOptions () {
      return this.processOptions(this.mergedOptions)
    },
    mergedOptions () {
      let mergedOptions = JSON.parse(JSON.stringify(this.defaultOptions))
      for (let option in this.options) {
        mergedOptions[option] = this.options[option]
      }
      return mergedOptions
    }
  },
  created () {
    this.getReport()
  }
}


// WEBPACK FOOTER //
// ./src/reports/components/mixins/reportView.js